import { useModules } from '@contexts/modules-provider';
import { useHasPermission } from '@contexts/permissions-provider';
import { CommonHomeContent } from '@pages/home/components/common-home-content/CommonHomeContent';
import { ManageHomeContent } from '@pages/home/components/manage-home-content/ManageHomeContent';
import * as React from 'react';

const HomePage = React.memo((): React.ReactElement => {
  const { selectedModule } = useModules();
  const hasManageAccess = useHasPermission('ModuleManage_View_Any');

  return (
    <>
      {selectedModule?.name === 'Manage' && hasManageAccess && (
        <ManageHomeContent />
      )}
      {!selectedModule && <CommonHomeContent />}
    </>
  );
});

HomePage.displayName = 'HomePage';

export { HomePage };
